import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import * as S from "./styles";
import { useInactivityModal } from "./useInactivityModal";

export const InactivityModal: React.FC = () => {
  const { isOpen, modalData, handleConfirm } = useInactivityModal();

  if (!isOpen) return null;

  return (
    <S.Overlay>
      <S.ModalContainer>
        <S.IconWrapper>
          <FiAlertTriangle />
        </S.IconWrapper>

        <S.Title>{modalData.title}</S.Title>
        <S.Message>{modalData.message}</S.Message>

        <S.PrimaryButton onClick={handleConfirm}>
          OK
        </S.PrimaryButton>
      </S.ModalContainer>
    </S.Overlay>
  );
};